import React from "react";
import Prodoct from "../../Products/Product/Product";
import Review from "../../Review/Review/Review";
import Banner from "../Banner/Banner";
import ExtraSection from "../ExtraSection/ExtraSectioin";

const Home = () => {
  return (
    <div>
      <Banner />
      <ExtraSection />
      <Prodoct />
      <Review />
    </div>
  );
};

export default Home;
